import { Text } from '../../../Text';
import { Props } from './types';

export const InputError = ({ errorText }: Props) => {
	return (
		<Text status="danger" category="label">
			{errorText}
		</Text>
	);
};
